<script context="module" lang="ts">
	export type IconType =
		| 'error'
		| 'success'
		| 'emptyCircle'
		| 'selectedCircle'
		| 'loading-spinner'
		| 'infoNotification'
		| 'errorNotification'
		| 'warningNotification'
		| 'checkmark'
		| 'plus'
		| 'close'
		| 'login'
		| 'banner-success'
		| 'banner-info'
		| 'banner-error'
		| 'external'
		| 'external-blue'
		| 'blue-checkmark'
		| 'gray-checkmark'
		| 'down-arrow'
		| 'internationalization';
</script>

<script lang="ts">
	export let icon: IconType;
	export let extraClass = '';
</script>

<div class="flex {extraClass}">
	{#if icon === 'error'}
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M8 16C3.589 16 0 12.411 0 8C0 3.589 3.589 0 8 0C12.411 0 16 3.589 16 8C16 12.411 12.411 16 8 16"
				fill="#D0130F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M8.00028 9.14314C8.63228 9.14314 9.14314 8.67485 9.14314 8.09552V3.90504C9.14314 3.32571 8.63228 2.85742 8.00028 2.85742C7.36828 2.85742 6.85742 3.32571 6.85742 3.90504V8.09552C6.85742 8.67485 7.36828 9.14314 8.00028 9.14314"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M8.00028 10.8574C7.36963 10.8574 6.85742 11.3688 6.85742 12.0008C6.85742 12.6317 7.36963 13.1431 8.00028 13.1431C8.63093 13.1431 9.14314 12.6317 9.14314 12.0008C9.14314 11.3688 8.63093 10.8574 8.00028 10.8574"
				fill="white"
			/>
		</svg>
	{:else if icon === 'success'}
		<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M14.9279 21.323L10.5754 16.9706C9.98959 16.3848 9.03984 16.3848 8.45406 16.9706C7.86827 17.5564 7.86827 18.5061 8.45406 19.0919L13.7574 24.3952C14.0782 24.716 14.5082 24.8611 14.9279 24.8305C15.3475 24.8611 15.7775 24.716 16.0983 24.3952L26.705 13.7886C27.2907 13.2028 27.2907 12.253 26.705 11.6673C26.1192 11.0815 25.1694 11.0815 24.5836 11.6673L14.9279 21.323Z"
				fill="#0DA400"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M0 18C0 8.05887 8.05887 0 18 0C27.9411 0 36 8.05887 36 18C36 27.9411 27.9411 36 18 36C8.05887 36 0 27.9411 0 18ZM33 18C33 9.71573 26.2843 3 18 3C9.71573 3 3 9.71573 3 18C3 26.2843 9.71573 33 18 33C26.2843 33 33 26.2843 33 18Z"
				fill="#0DA400"
			/>
		</svg>
	{:else if icon === 'emptyCircle'}
		<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12.5" cy="12" r="11" fill="white" stroke="#707070" stroke-width="2" />
		</svg>
	{:else if icon === 'selectedCircle'}
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12" cy="12" r="11" fill="white" stroke="#CCCCCC" stroke-width="2" />
			<circle cx="12" cy="12" r="12" fill="#009E3F" />
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M18.1056 7.50919C18.4976 7.92249 18.4976 8.59257 18.1056 9.00587L11.0085 16.4892C10.7939 16.7156 10.5062 16.818 10.2254 16.7964C9.9445 16.818 9.6568 16.7156 9.44213 16.4892L5.89358 12.7476C5.50162 12.3343 5.50162 11.6642 5.89358 11.2509C6.28554 10.8376 6.92104 10.8376 7.313 11.2509L10.2246 14.3206L16.6862 7.50919C17.0782 7.09589 17.7137 7.09589 18.1056 7.50919Z"
				fill="white"
			/>
		</svg>
	{:else if icon === 'loading-spinner'}
		<svg
			class="animate-spin"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
			style="height: 1em;"
		>
			<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
			<path
				class="opacity-75"
				fill="currentColor"
				d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
			/>
		</svg>
	{:else if icon === 'infoNotification'}
		<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z"
				fill="#31708F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M15.75 18.6667V13.6667C15.75 12.745 14.966 12 14 12H12.25C11.284 12 10.5 12.745 10.5 13.6667C10.5 14.5883 11.284 15.3333 12.25 15.3333V20.3333C12.25 21.255 13.034 22 14 22H15.75C16.716 22 17.5 21.255 17.5 20.3333C17.5 19.4117 16.716 18.6667 15.75 18.6667Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M14 9C15.1036 9 16 8.10505 16 6.99909C16 5.89495 15.1036 5 14 5C12.8964 5 12 5.89495 12 6.99909C12 8.10505 12.8964 9 14 9Z"
				fill="white"
			/>
		</svg>
	{:else if icon === 'errorNotification'}
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
				fill="#D0130F"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M5.14299 12.0001C5.14299 10.4179 5.68728 8.96329 6.58985 7.80272L16.1976 17.4104C15.0361 18.313 13.5824 18.8573 12.0001 18.8573C8.21928 18.8573 5.14299 15.781 5.14299 12.0001ZM17.4104 16.1976L7.8027 6.58984C8.96413 5.68726 10.4178 5.14298 12.0001 5.14298C15.781 5.14298 18.8573 8.21926 18.8573 12.0001C18.8573 13.5824 18.313 15.037 17.4104 16.1976ZM3.42871 12.0001C3.42871 16.7264 7.27385 20.5716 12.0001 20.5716C16.7264 20.5716 20.5716 16.7264 20.5716 12.0001C20.5716 7.27385 16.7264 3.42871 12.0001 3.42871C7.27385 3.42871 3.42871 7.27385 3.42871 12.0001Z"
				fill="white"
			/>
		</svg>
	{:else if icon === 'close'}
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 12" fill="none" style="height: .8em;">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M7.41413 6.00001L11.7071 1.70701C12.0981 1.31601 12.0981 0.684006 11.7071 0.293006C11.3161 -0.0979941 10.6841 -0.0979941 10.2931 0.293006L6.00013 4.58601L1.70713 0.293006C1.31613 -0.0979941 0.684128 -0.0979941 0.293128 0.293006C-0.0978721 0.684006 -0.0978721 1.31601 0.293128 1.70701L4.58613 6.00001L0.293128 10.293C-0.0978721 10.684 -0.0978721 11.316 0.293128 11.707C0.488128 11.902 0.744128 12 1.00013 12C1.25613 12 1.51213 11.902 1.70713 11.707L6.00013 7.41401L10.2931 11.707C10.4881 11.902 10.7441 12 11.0001 12C11.2561 12 11.5121 11.902 11.7071 11.707C12.0981 11.316 12.0981 10.684 11.7071 10.293L7.41413 6.00001Z"
				fill="currentColor"
			/>
		</svg>
	{:else if icon === 'warningNotification'}
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12 24C5.3835 24 0 18.6165 0 12C0 5.3835 5.3835 0 12 0C18.6165 0 24 5.3835 24 12C24 18.6165 18.6165 24 12 24Z"
				fill="#FFC827"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M11.9999 13.7147C12.9479 13.7147 13.7142 13.0123 13.7142 12.1433V5.85756C13.7142 4.98856 12.9479 4.28613 11.9999 4.28613C11.0519 4.28613 10.2856 4.98856 10.2856 5.85756V12.1433C10.2856 13.0123 11.0519 13.7147 11.9999 13.7147Z"
				fill="white"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M11.9999 16.2861C11.054 16.2861 10.2856 17.0532 10.2856 18.0012C10.2856 18.9476 11.054 19.7147 11.9999 19.7147C12.9459 19.7147 13.7142 18.9476 13.7142 18.0012C13.7142 17.0532 12.9459 16.2861 11.9999 16.2861Z"
				fill="white"
			/>
		</svg>
	{:else if icon === 'checkmark'}
		<svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M5.57751 7.64674L4.12669 6.19592C3.93143 6.00065 3.61484 6.00065 3.41958 6.19592C3.22432 6.39118 3.22432 6.70776 3.41958 6.90302L5.18735 8.67079C5.2943 8.77774 5.43764 8.82611 5.57751 8.8159C5.71738 8.82611 5.86073 8.77774 5.96768 8.67079L9.50321 5.13526C9.69847 4.93999 9.69847 4.62341 9.50321 4.42815C9.30795 4.23289 8.99137 4.23289 8.79611 4.42815L5.57751 7.64674Z"
				fill="#0DA400"
			/>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M0.601562 6.53906C0.601562 3.22535 3.28785 0.539062 6.60156 0.539062C9.91527 0.539062 12.6016 3.22535 12.6016 6.53906C12.6016 9.85277 9.91527 12.5391 6.60156 12.5391C3.28785 12.5391 0.601562 9.85277 0.601562 6.53906ZM11.6016 6.53906C11.6016 3.77764 9.36299 1.53906 6.60156 1.53906C3.84014 1.53906 1.60156 3.77764 1.60156 6.53906C1.60156 9.30049 3.84014 11.5391 6.60156 11.5391C9.36299 11.5391 11.6016 9.30049 11.6016 6.53906Z"
				fill="#0DA400"
			/>
		</svg>
	{:else if icon === 'plus'}
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"
			><path
				d="M9 6.06668V11.9333"
				stroke="green"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/><path
				d="M6.06641 9H11.9331"
				stroke="green"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/><path
				clip-rule="evenodd"
				fill-rule="evenodd"
				d="M8.99935 16.3333C13.0494 16.3333 16.3327 13.0501 16.3327 9C16.3327 4.94992 13.0494 1.66667 8.99935 1.66667C4.94926 1.66667 1.66602 4.94992 1.66602 9C1.66602 13.0501 4.94926 16.3333 8.99935 16.3333Z"
				stroke="green"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/></svg
		>
	{:else if icon === 'login'}
		<svg
			width="36"
			height="36"
			viewBox="0 0 36 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<rect width="36" height="36" fill="url(#pattern0)" />
			<defs>
				<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
					<use xlink:href="#image0_870_21224" transform="scale(0.00195312)" />
				</pattern>
				<image
					id="image0_870_21224"
					width="512"
					height="512"
					xlink:href="data:image/png;base64,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"
				/>
			</defs>
		</svg>
	{:else if icon === 'banner-success'}
		<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M0.875 12C0.875 5.37258 6.24758 0 12.875 0C19.5024 0 24.875 5.37258 24.875 12C24.875 18.6274 19.5024 24 12.875 24C6.24758 24 0.875 18.6274 0.875 12Z"
				fill="#007828"
			/>
			<path
				d="M11.4838 14.7301L8.58211 11.8284C8.19158 11.4379 7.55842 11.4379 7.16789 11.8284C6.77737 12.219 6.77737 12.8521 7.16789 13.2426L10.7034 16.7782C10.9173 16.9921 11.204 17.0888 11.4838 17.0684C11.7635 17.0888 12.0502 16.9921 12.2641 16.7782L19.3352 9.70711C19.7257 9.31658 19.7257 8.68342 19.3352 8.29289C18.9446 7.90237 18.3115 7.90237 17.9209 8.29289L11.4838 14.7301Z"
				fill="white"
			/>
		</svg>
	{:else if icon === 'banner-info'}
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M12 24C5.37258 24 5.79388e-07 18.6274 0 12C-5.79387e-07 5.37258 5.37258 5.79387e-07 12 0C18.6274 -5.79387e-07 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z"
				fill="#027ABB"
			/>
			<path
				d="M13.7983 7.8275C14.1438 7.50618 14.3165 7.11605 14.3165 6.65854C14.3165 6.20178 14.1438 5.8118 13.7983 5.48754C13.4529 5.16316 13.038 5 12.5516 5C12.0672 5 11.6483 5.16316 11.3008 5.48754C10.9554 5.8118 10.7808 6.20178 10.7808 6.65854C10.7808 7.11605 10.9554 7.50618 11.3008 7.8275C11.6483 8.14879 12.0672 8.31002 12.5516 8.31002C13.038 8.31002 13.4529 8.14879 13.7983 7.8275ZM13.0022 18.5712C13.6256 18.2796 13.9552 17.7315 13.6316 17.4808C13.445 17.3365 13.2007 17.5753 13.0221 17.5753C12.639 17.5753 12.3689 17.5125 12.2141 17.3863C12.0573 17.2589 11.9818 17.0231 11.9818 16.6749C11.9818 16.5357 12.0037 16.3317 12.0513 16.062C12.099 15.7915 12.1546 15.5497 12.2141 15.3388L12.9546 12.7163C13.0241 12.4755 13.0757 12.2108 13.1035 11.9233C13.1293 11.6327 13.1433 11.4318 13.1433 11.3183C13.1433 10.7662 12.9487 10.3165 12.5615 9.97026C12.1764 9.62516 11.6245 9.45092 10.9098 9.45092C10.5127 9.45092 10.0899 9.50963 9.64719 9.66283C8.77962 9.96722 8.97221 10.7235 9.16474 10.7235C9.55582 10.7235 9.81789 10.79 9.95687 10.9224C10.0958 11.0537 10.1673 11.2875 10.1673 11.6248C10.1673 11.8098 10.1415 12.0178 10.0978 12.2426C10.0521 12.4675 9.99861 12.7072 9.93111 12.9589L9.18661 15.5914C9.12311 15.868 9.07537 16.1157 9.04365 16.3355C9.01389 16.5555 9 16.7704 9 16.9814C9 17.5216 9.19848 17.9672 9.5975 18.3194C9.99662 18.6726 10.6101 19 11.3287 19C11.7952 19 12.4623 18.826 13.0022 18.5712Z"
				fill="white"
			/>
		</svg>
	{:else if icon === 'banner-error'}
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12 3.42857C16.7262 3.42857 20.5714 7.27356 20.5714 12C20.5714 16.7262 16.7262 20.5714 12 20.5714C7.2738 20.5714 3.42857 16.7262 3.42857 12C3.42857 7.2738 7.2738 3.42857 12 3.42857ZM17.7144 12C17.7144 8.84902 15.151 6.28561 12 6.28561L12.0001 6.28573C10.9422 6.28573 9.95401 6.57987 9.10344 7.08303L16.9171 14.8967C17.4203 14.0461 17.7144 13.0577 17.7144 12ZM7.08267 9.10332C6.57949 9.95389 6.28537 10.9423 6.28537 12L6.28561 12.0002C6.28561 15.1512 8.84926 17.7149 12.0002 17.7149C13.058 17.7149 14.0461 17.4207 14.8969 16.9176L7.08267 9.10332Z"
				fill="#DD0000"
			/>
		</svg>
	{:else if icon === 'external'}
		<svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M2.25 1.16667C1.92783 1.16667 1.66667 1.42783 1.66667 1.75V12.25C1.66667 12.5722 1.92783 12.8333 2.25 12.8333H12.75C13.0722 12.8333 13.3333 12.5722 13.3333 12.25V7.58333H14.5V12.25C14.5 13.2165 13.7165 14 12.75 14H2.25C1.2835 14 0.5 13.2165 0.5 12.25V1.75C0.5 0.783501 1.2835 0 2.25 0H6.91667V1.16667H2.25Z"
				fill="white"
			/>
			<path
				d="M13.3333 5.83333V1.99162L6.74581 8.57915C6.51801 8.80695 6.14866 8.80695 5.92085 8.57915C5.69305 8.35134 5.69305 7.98199 5.92085 7.75419L12.5084 1.16667L8.66667 1.16667V0H13.3333C13.9777 0 14.5 0.522334 14.5 1.16667V5.83333H13.3333Z"
				fill="white"
			/>
		</svg>
	{:else if icon === 'external-blue'}
		<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M2.25 1.5C1.83579 1.5 1.5 1.83579 1.5 2.25V15.75C1.5 16.1642 1.83579 16.5 2.25 16.5H15.75C16.1642 16.5 16.5 16.1642 16.5 15.75V9.75H18V15.75C18 16.9926 16.9926 18 15.75 18H2.25C1.00736 18 0 16.9926 0 15.75V2.25C0 1.00736 1.00736 0 2.25 0H8.25V1.5H2.25Z"
				fill="#0061FF"
			/>
			<path
				d="M16.5 7.5V2.56066L8.03033 11.0303C7.73744 11.3232 7.26256 11.3232 6.96967 11.0303C6.67678 10.7374 6.67678 10.2626 6.96967 9.96967L15.4393 1.5L10.5 1.5V0H16.5C17.3284 0 18 0.671572 18 1.5V7.5H16.5Z"
				fill="#0061FF"
			/>
		</svg>
	{:else if icon === 'gray-checkmark'}
		<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.5 8L7.21752 11.5136L13.3996 4.97284"
				stroke="#707070"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	{:else if icon === 'blue-checkmark'}
		<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M3.5 8L7.21752 11.5136L13.3996 4.97284"
				stroke="#1A47E8"
				stroke-width="2"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	{:else if icon === 'down-arrow'}
		<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.91406 3.95703L5.97479 7.95703L9.91406 3.95703"
				stroke="#707070"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	{:else if icon === 'internationalization'}
		<svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.54442 1.00036C7.37666 1.00938 0.999858 1.7231 1 8.58921M8.54442 1.00036C9.98128 1.01851 16.0887 1.99413 15.999 8.58921M8.54442 1.00036C7.82573 1.00035 5.67018 1.78426 5.84998 8.58921M8.54442 1.00036C8.81369 1.00036 11.149 0.819672 11.149 8.58921M1 8.58921C1.35908 15.2746 7.6461 15.9974 8.36479 15.9974M1 8.58921C2.89404 8.58921 3.95595 8.58921 5.84998 8.58921M8.36479 15.9974C9.08348 15.9974 15.909 15.8167 15.999 8.58921M8.36479 15.9974C8.36479 15.9974 5.75999 16.2684 5.84998 8.58921M8.36479 15.9974C8.36479 15.9974 11.149 16.3587 11.149 8.58921M15.999 8.58921C14.105 8.58921 13.0431 8.58921 11.149 8.58921M2.99111 3.25894C2.99111 3.25894 6.23672 5.89359 8.54442 5.87891C10.8202 5.86443 14.0227 3.25894 14.0227 3.25894M3.15555 13.6552C3.15555 13.6552 6.1362 11.3914 8.36479 11.2995C10.8191 11.1983 14.2026 13.6552 14.2026 13.6552M5.84998 8.58921C7.91939 8.58921 9.07963 8.58921 11.149 8.58921"
				stroke="#0061FF"
			/>
			<path
				d="M9 10.5V16.7C9 16.9761 9.22386 17.2 9.5 17.2H15L16.5 19V17.2H17.5C17.7761 17.2 18 16.9761 18 16.7V10.5C18 10.2239 17.7761 10 17.5 10H9.5C9.22386 10 9 10.2239 9 10.5Z"
				fill="white"
			/>
			<path
				d="M16.5 17.2V16.7H16V17.2H16.5ZM16.5 19L16.1159 19.3201C16.2507 19.4818 16.4723 19.5418 16.6702 19.4701C16.8681 19.3985 17 19.2105 17 19H16.5ZM15 17.2L15.3841 16.8799L15.2342 16.7H15V17.2ZM9.5 16.7V10.5H8.5V16.7H9.5ZM9.5 10.5H17.5V9.5H9.5V10.5ZM17.5 10.5V16.7H18.5V10.5H17.5ZM17.5 16.7H16.5V17.7H17.5V16.7ZM16 17.2V19H17V17.2H16ZM16.8841 18.6799L15.3841 16.8799L14.6159 17.5201L16.1159 19.3201L16.8841 18.6799ZM15 16.7H9.5V17.7H15V16.7ZM17.5 16.7V17.7C18.0523 17.7 18.5 17.2523 18.5 16.7H17.5ZM17.5 10.5H18.5C18.5 9.94772 18.0523 9.5 17.5 9.5V10.5ZM9.5 10.5V10.5V9.5C8.94771 9.5 8.5 9.94772 8.5 10.5H9.5ZM8.5 16.7C8.5 17.2523 8.94771 17.7 9.5 17.7V16.7H9.5H8.5Z"
				fill="#0061FF"
			/>
			<path
				d="M11.5 12.5H14.1667M11.5 14.5H15.5"
				stroke="#0061FF"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	{/if}
</div>
